import React, {FC} from 'react';
import Avatar from '@material-ui/core/Avatar';
import {useDispatch, useSelector} from 'react-redux';
import {useAuthUser} from '../../utility/AppHooks';
import {makeStyles} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Box from '@material-ui/core/Box';
import {blueGrey, orange} from '@material-ui/core/colors';
import {Fonts} from '../../../shared/constants/AppEnums';
import Hidden from '@material-ui/core/Hidden';
import {onSignOutFirebaseUser} from 'redux/actions/FirebaseAuth';
import {useHistory} from 'react-router-dom';
import { AppState } from 'redux/store';
import {getUserAvatar} from "../../utility/Utils";
import { AuthUser } from 'types/models/AuthUser';


const useStyles = makeStyles((theme) => {
  return {
    userRoot: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      justifyContent: 'center',
    },
    avatar: {
      fontSize: 18,
      backgroundColor: blueGrey[700],
    },
    userInfo: {
      width: 'calc(100% - 75px)',
    },
    pointer: {
      cursor: 'pointer',
    },
    userName: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      fontSize: 15,
      fontWeight: Fonts.MEDIUM,
      color: (props: {bgType: string}) =>
        props.bgType === 'colored' ? 'white' : theme.palette.text.primary,
    },
  };
});

interface HorUserInfoProps {
  bgType?: string;
}

const HorUserInfo: FC<HorUserInfoProps> = ({bgType = 'colored'}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const authUser = useSelector<AppState, AuthUser | null>(({auth}) => auth.authUser);
  const nameAvatar = getUserAvatar(authUser)

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const classes = useStyles({bgType});

  return (
    <Box py={2} pl={{xs: 2, sm: 3, md: 5}}>
      <Box className={classes.userRoot} display='flex' onClick={handleClick}>
        {authUser && authUser.photoURL ? (
          <Avatar className={classes.avatar} src={authUser.photoURL} />
        ) : (
          <Avatar className={classes.avatar}>{nameAvatar}</Avatar>
        )}
        <Hidden mdDown>
          <Box ml={3} className={classes.userName}>
            {authUser && (authUser.displayName ? authUser.displayName : authUser.email)}
            <Box fontSize={13} fontWeight={Fonts.LIGHT}></Box>
          </Box>
        </Hidden>
      </Box>
      <Box className={classes.userInfo}>
        <Menu
          id='simple-menu'
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}>
          <MenuItem
            onClick={() => {
              // console.log('clicked');
              history.push('/myaccount');
              handleClose();
            }}>
            My account
          </MenuItem>
          <MenuItem onClick={() => dispatch(onSignOutFirebaseUser())}>
            Logout
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default HorUserInfo;